import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { RootState } from 'src/store/index';
// import dayjs from 'src/libs/dayjs';

export type State = {
  loading: boolean;
  search: {
    params: SearchParams.ClassUserStatus;
    ids: string[];
  };
  closed: boolean;
};

export const adapter = createEntityAdapter<Model.ClassUserStatus>({
  selectId: (model) => model.id,
  // sortComparer: (a, b) => {
  //   return dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? 1 : -1;
  // },
});

const { reducer, actions } = createSlice({
  name: 'classUserStatus',
  initialState: adapter.getInitialState<State>({
    loading: false,
    search: {
      ids: [],
      params: {},
    },
    closed: false,
  }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.ClassUserStatus[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.ClassUserStatus>) {
      adapter.upsertOne(state, action);
      state.search.ids = [...(state.search.ids || []), action.payload.id];
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    removeEntity(state, action: PayloadAction<Model.ClassUserStatus>) {
      adapter.removeOne(state, action.payload.id);
      state.search.ids = (state.search.ids || []).filter(
        (id) => id !== action.payload.id,
      );
    },
    updateSearch(state, action: PayloadAction<State['search']>) {
      state.search = action.payload;
    },
    updateHasClose(state, action: PayloadAction<boolean>) {
      state.closed = action.payload;
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.class_user_status,
);

export const selectClassUserStatus = createSelector(
  selector.selectAll,
  (list = []) => {
    const launchpads = list.filter((item) => item.class.type === 'LAUNCHPAD');

    return launchpads || [];
  },
);

export const selectClassUserStatusByClassId = createSelector(
  selector.selectAll,
  (state: RootState, class_id: string) => class_id,
  (list = [], class_id) => {
    const c = list
      .filter((item) => item.class.type === 'LAUNCHPAD')
      .find((s) => s.class_id === class_id);

    return c || ({} as Model.ClassUserStatus);
  },
);

export { reducer };
export default actions;
